'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import { CheckIcon, ExternalLink, UserRoundCheck } from 'lucide-react';
import Link from 'next/link';
import AchraLarge from '@/modules/shared/components/svgs/achra-large.svg';
import AchraRounded from '@/modules/shared/components/svgs/achra-rounded.svg';
import BookCall from '@/modules/shared/components/svgs/book-call.svg';
import PhoneLarge from '@/modules/shared/components/svgs/phone-large.svg';
import { OPERATIONAL_HUB_URL } from '@/modules/shared/lib/constants';
import { useServicePurchaseState } from '../../providers/service-purchase-store-provider';
import { ActionCard } from './action-card';
import type { Route } from 'next';
function ConfirmationStep() {
  const $ = _c(23);
  const {
    requestEntityData
  } = useServicePurchaseState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex flex-col items-center gap-6 px-0");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-muted w-fit rounded-lg p-2"><CheckIcon className="text-foreground size-6" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-foreground text-lg/5.5 font-bold">Request Successfully Sent!</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = requestEntityData?.name;
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="text-primary font-semibold">{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = requestEntityData?.email;
  let t7;
  if ($[6] !== t6) {
    t7 = <span className="text-primary">{t6}</span>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t7) {
    t9 = <div className="flex flex-col items-center gap-4">{t1}<div className="flex flex-col items-center gap-2">{t2}<span className="text-foreground/50 text-center text-sm/5.5">Thank you{" "}{t4}!{t5}{" "}We have emailed the summary to{" "}{t7}{t8} We will contact you shortly to schedule an introduction meeting!</span></div></div>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BookCall className="size-6 min-w-6 rounded-md" />;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href={OPERATIONAL_HUB_URL}><ActionCard icon={t10} title="Book a Call" description="Schedule a call to get started" bgImage={<PhoneLarge className="absolute top-0 right-0 h-full" />} /></Link>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <AchraRounded className="size-6 min-w-6 rounded-md" />;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">{t11}<Link href="/services"><ActionCard icon={t12} title="Explore ACHRA" description="Learn more about the ecosystem and other available" bgImage={<AchraLarge className="absolute top-0 right-0 h-full" />} /></Link></div>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t9) {
    t14 = <Card className="bg-background border-border mt-16 self-center rounded-lg p-6 shadow-xs"><CardContent className={t0}>{t9}{t13}</CardContent></Card>;
    $[16] = t9;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== requestEntityData) {
    t15 = requestEntityData?.driveUrl && <Card className="bg-background border-border w-full self-center rounded-lg p-6 shadow-xs"><CardContent className={cn("flex flex-col items-center gap-6 px-0")}><div className="flex flex-col items-center gap-4"><div className="bg-muted w-fit rounded-lg p-2"><UserRoundCheck className="text-foreground size-6" /></div><div className="flex flex-col items-center gap-2"><span className="text-foreground text-lg/5.5 font-bold">You're all set!</span></div></div><Button variant="outline" className="w-full" asChild={true}><Link href={requestEntityData.driveUrl as Route} target="_blank" rel="noopener noreferrer">Go to your workspace <ExternalLink /></Link></Button></CardContent></Card>;
    $[18] = requestEntityData;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t14 || $[21] !== t15) {
    t16 = <div className="mx-auto flex w-full flex-col items-center gap-6 md:max-w-156">{t14}{t15}</div>;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  return t16;
}
export { ConfirmationStep };